/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Protocol_Field_Arms_ClearInputs */

const en_us2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`arms against the body`)
};

const pt_br2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`braços encostados no corpo`)
};

const es_419_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`brazos pegados al cuerpo`)
};

const pt_pt2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`braços encostados ao corpo`)
};

const fr_fr2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bras collés au corps`)
};

const de_de2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arme am Körper`)
};

const it_it2_body_assessment_protocol_field_arms_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Arms_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`braccia attaccate al corpo`)
};

/**
* | output |
* | --- |
* | "arms against the body" |
*
* @param {Body_Assessment_Protocol_Field_Arms_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_protocol_field_arms_clear = /** @type {((inputs?: Body_Assessment_Protocol_Field_Arms_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Protocol_Field_Arms_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_protocol_field_arms_clear(inputs)
	if (locale === "es-419") return es_419_body_assessment_protocol_field_arms_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_protocol_field_arms_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_protocol_field_arms_clear(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_protocol_field_arms_clear(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_protocol_field_arms_clear(inputs)
	return en_us2_body_assessment_protocol_field_arms_clear(inputs)
});
export { body_assessment_protocol_field_arms_clear as "body-assessment.protocol_field.arms_clear" }